export default __webpack_public_path__ + "static/media/grayHeartIcon.a6e1fcdf.svg";